export default __webpack_public_path__ + "static/media/check.3870176b.svg";